<script>
// @ts-check

import { featureEnabled } from '@/helpers/functions'
import { UKKOTURVA_ROUTE_ROOT } from '@/router/ukkoturvaRoutes'
import BaseInnerNavigationView from '@/views/BaseInnerNavigationView.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'UkkoturvaIndex',
  components: {
    BaseInnerNavigationView
  },
  computed: {
    ...mapGetters('companyData', ['features', 'isInDemoMode']),
    routes() {
      return UKKOTURVA_ROUTE_ROOT.children
    },
    insurancesAreActive() {
      // Check demomode mainly for TLP but no harm for other services either
      if (
        featureEnabled(this.features, 'ukko_assurance') &&
        !this.isInDemoMode
      ) {
        return []
      }
      return ['ukkoturva_insurances_certificates']
    }
  }
}
</script>

<template>
  <!-- Mobile navigation can be found in UkkoAssuranceContainer.vue -->
  <BaseInnerNavigationView
    :title="$t(`routes.ukkoturva`)"
    :routes
    disable-template
    disable-mobile-navigation
    :disabled-routes="insurancesAreActive"
  />
</template>
